import { render, staticRenderFns } from "./TipoCarga.vue?vue&type=template&id=052aa38b"
import script from "./TipoCarga.vue?vue&type=script&lang=js"
export * from "./TipoCarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports